import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";

// Components
import Preloader from "./components/Preloader";
import ScrollToTop from "./components/ScrollToTop";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

// Pages
import Hero from "./components/Hero";
import Contact from "./components/Contact";
import Coffee from "./components/Coffee";
import Certificates from "./components/Certificates";
import About from "./components/About";
import Farm from "./components/Farm";
// Ensure this path matches where you saved the Green Coffee file
import GreenCoffee from "./components/GreenCoffee"; 
import RoastedCoffee from "./components/RoastedCoffee";

function PageLoader({ children }) {
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500); 
    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <>
      <div style={{ 
        opacity: loading ? 1 : 0, 
        visibility: loading ? 'visible' : 'hidden',
        transition: 'opacity 0.4s ease-in-out',
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 10000 
      }}>
        {loading && <Preloader />}
      </div>
      {children}
    </>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <PageLoader>
        <Navbar />

        {/* --- ANIMATED FLOATING WHATSAPP ICON --- */}
        <a 
          href="https://wa.me/919552794179?text=Hello%20Aditya%20Exports%20Ventures!%20I%20am%20interested%20in%20your%20coffee%20beans." 
          className="whatsapp-float" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          <img 
            src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" 
            alt="WhatsApp" 
          />
        </a>

        <Routes>
          <Route path="/" element={<Hero />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          {/* <Route path="/coffee" element={<Coffee />} /> */}
          
          {/* --- ADDED THIS ROUTE --- */}
          <Route path="/coffee/green" element={<GreenCoffee />} />
          <Route path="/coffee/roasted" element={<RoastedCoffee />} />
          
          <Route path="/certificates" element={<Certificates />} />
          <Route path="/farm" element={<Farm />} />
        </Routes>
        
        <Footer />
      </PageLoader>
    </Router>
  );
}

export default App;
